import React, { forwardRef, useRef } from "react";
import { ALL_ICONS } from "../../assets/icons/AllIcons";
import { cn } from "../razor-reuse/helper/helper";

interface CustomModalProp {
  containerClass?: string;
  children: React.ReactNode;
  onClose: () => void;
  headerTitle?: string;
}

const CustomModal = forwardRef<HTMLDialogElement, CustomModalProp>(
  ({ containerClass, children, onClose, headerTitle }, ref) => {
    React.useEffect(() => {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === "Escape") onClose();
      };

      const dialog = ref as React.RefObject<HTMLDialogElement>;
      const currentDialog = (dialog as any)?.current;

      currentDialog?.addEventListener("keydown", handleKeyDown);
      return () => {
        currentDialog?.removeEventListener("keydown", handleKeyDown);
      };
    }, [onClose, ref]);

    return (
      <dialog
        ref={ref}
        className={cn(
          "backdrop:bg-black/50 backdrop:backdrop-blur-sm p-0 border-none overflow-y-auto relative w-[560px] h-fit m-auto max-w-[90%] max-h-[95%] bg-[#F7F7F7]",
          containerClass
        )}
      >
        {headerTitle && (
          <div className="flex justify-between items-center bg-white py-[12px] px-[28px] sticky top-0 z-[20]">
            <p className="text-[18px] font-medium text-[#252C32]">
              {headerTitle}
            </p>
            <figure
              onClick={onClose}
              className="size-[24px] cursor-pointer rounded-full bg-[#FFEFEB]"
            >
              {ALL_ICONS?.close_modal}
            </figure>
          </div>
        )}
        {children}
      </dialog>
    );
  }
);

CustomModal.displayName = "CustomModal";
export default CustomModal;

export function useDialogToggle() {
  const dialogRef = useRef<HTMLDialogElement | null>(null);

  const openDialog = () => {
    dialogRef.current?.showModal();
  };

  const closeDialog = () => {
    dialogRef.current?.close();
  };
  return {
    dialogRef,
    openDialog,
    closeDialog,
  };
}
